export enum INVOICESTATUS_ENUM {
  HOLD = 'HOLD',
  RELEASED = 'RELEASED',
  REVERT = 'REVERT',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
};